//组件对象，大写
import flashAddMedicalAndCurdArray from './flashAddMedicalAndCurdArray.vue'
export default flashAddMedicalAndCurdArray
